import { API_URL } from '../config';
import axios from 'axios';

export default class ApiService {
    static createdInstance = null;
    static getInstance() {
        if (ApiService.createdInstance === null) {
            ApiService.createdInstance = new ApiService();
        }
        return ApiService.createdInstance;
    }

    startLoaderTask = (taskConfig = null) => {
        if (
            typeof window.edsLoader === 'object' &&
            typeof window.edsLoader.startTask === 'function'
        ) {
            return window.edsLoader.startTask(taskConfig);
        } else {
            return false;
        }
    };

    stopLoaderTask = (taskId) => {
        if (
            typeof window.edsLoader === 'object' &&
            typeof window.edsLoader.endTask === 'function'
        ) {
            return window.edsLoader.endTask(taskId);
        } else {
            return false;
        }
    };

    logout(redirect = true) {
        localStorage.clear();
        if (typeof redirect === 'boolean' && redirect) {
            window.location.hash = '/Error_sesja_wygasla';
        }
    }

    /**
     * @param methodName name of method to call
     * @param callback
     * @param redirectOnUnauthorized    Default true - if no token or status 401 returned, automatically clear localstorage and redirect user to login screen.
     *                                  SET FALSE ONLY WHEN DOING REQUESTS FROM LOGIN SCREEN, REGISTRATION SCREEN ETC
     */
    apiGet(methodName, callback, redirectOnUnauthorized = true) {
        if (
            typeof methodName === 'string' &&
            methodName.length > 0 &&
            typeof callback === 'function'
        ) {
            const that = this;
            const token = localStorage.getItem('token');

            if (
                (typeof token === 'string' && token.length > 0) ||
                redirectOnUnauthorized === false
            ) {
                const url = API_URL + methodName;
                const config = { headers: { Authorization: 'Bearer ' + token } };

                const loaderTaskId = this.startLoaderTask();

                // setTimeout(() => {
                axios
                    .get(url, config)
                    .then((response) => {
                        this.stopLoaderTask(loaderTaskId);

                        callback({ success: true, data: response.data });
                    })
                    .catch(function (error) {
                        that.stopLoaderTask(loaderTaskId);
console.log(error)
                        if (redirectOnUnauthorized === false) {
                            callback({ success: false, data: error.response.data });
                        } else {
                            if (error.response.status === 401) {
                                that.logout();
                            } else {
                                callback({ success: false, data: error.response.data });
                            }
                        }
                    });
                // }, 1000);
            } else {
                this.logout();
            }
        } else {
            console.error('incorrect parameters');
        }
    }

    async asyncApiGet(methodName, redirectOnUnauthorized = true) {
        return await new Promise((resolve, reject) => {
            this.apiGet(
                methodName,
                (response) => {
                    if (response.success) {
                        resolve(response.data);
                    } else {
                        reject();
                    }
                },
                redirectOnUnauthorized
            );
        });
    }

    /**
     * @param methodName name of method to call
     * @param payload data to send
     * @param callback
     * @param redirectOnUnauthorized    Default true - if no token or status 401 returned, automatically clear localstorage and redirect user to login screen.
     *                                  SET FALSE ONLY WHEN DOING REQUESTS FROM LOGIN SCREEN, REGISTRATION SCREEN ETC
     */
    apiPost(methodName, payload, callback, redirectOnUnauthorized = true) {
        if (
            typeof methodName === 'string' &&
            methodName.length > 0 &&
            typeof callback === 'function'
        ) {
            const that = this;
            const token = localStorage.getItem('token');
            

            if (
                (typeof token === 'string' && token.length > 0) ||
                redirectOnUnauthorized === false
            ) {
            
                const url = API_URL + methodName;
                const config = { headers: { Authorization: 'Bearer ' + token } };

                const loaderTaskId = this.startLoaderTask();
               
                // setTimeout(() => {
                axios
                    .post(url, payload, config)
                    .then((response) => {
                        this.stopLoaderTask(loaderTaskId);

                        callback({ success: true, data: response.data });
                    })
                    .catch(function (error) {
                        that.stopLoaderTask(loaderTaskId);
                        if (redirectOnUnauthorized === false) {
                            callback({ success: false, data: error.response.data });
                        } else {    
                            if(error.response!=undefined){                       
                            if (error.response.status === 401) {
                                that.logout();
                            } else {
                                if(error.response!=undefined){
                                callback({ success: false, data: error.response.data });}else{
                                    callback({ success: false, data: error });  
                                }
                            }}
                        }
                    });
                // }, 1000);
            } else {
                this.logout();
            }
        } else {
            console.error('incorrect parameters');
        }
    }

    async asyncApiPost(methodName, payload, redirectOnUnauthorized = true) {
        return await new Promise((resolve, reject) => {
            this.apiPost(
                methodName,
                payload,
                (response) => {
                    if (response.success) {
                        resolve(response.data);
                    } else {
                        reject();
                    }
                },
                redirectOnUnauthorized
            );
        });
    }

    login(payload, callback) {
        if (typeof callback === 'function') {
            const that = this;

            const url = API_URL + 'UserLogin';

            const loaderTaskId = this.startLoaderTask();

            // setTimeout(() => {
            axios
                .post(url, payload)
                .then((response) => {
                    this.stopLoaderTask(loaderTaskId);
                    callback({ success: true, data: response.data });
                })
                .catch(function (error) {
                    that.stopLoaderTask(loaderTaskId);
                    callback({ success: false, data: null });
                });
            // }, 1000);
        } else {
            console.error('incorrect parameters');
        }
    }

    apiPostChange(methodName, payload, callback, redirectOnUnauthorized = true) {
        if (typeof methodName === 'string' && methodName.length > 0 && typeof callback === 'function') {
            const that = this;
            const url = API_URL + methodName;
            const loaderTaskId = this.startLoaderTask();
            axios.post(url, payload).then((response) => {
                    this.stopLoaderTask(loaderTaskId);
                    callback({ success: true, data: response.data });
                }).catch(function (error) {
                    that.stopLoaderTask(loaderTaskId);
                    if (redirectOnUnauthorized === false) {
                        callback({ success: false, data: error.response.data });
                    } else {
                        if (error.response.status === 401) {
                            that.logout();
                        } else {
                            callback({ success: false, data: error.response.data });
                        }
                    }
                });
        } else {
            console.error('incorrect parameters');
        }
    }
}
